import goodsInfo from "../goods/index.vue";
import upload from "../upload/index.vue";

export default {
  components: {
    goodsInfo,
    upload,
  },
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "goods",
    },
    orderId: {
      type: String,
      default: "",
    },
    goodsVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      texts: ["非常差", "差", "一般", "好", "非常好"],
      colors: ["#fe5301", "#fe5301", "#fe5301"],
    };
  },
};
